import styled from "styled-components";

export const PageTitleContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;

    margin-bottom: 12px;

    box-shadow: var(--color-title-underline) 0 1px 0;
`;